import {throttle} from './throttle.js';

const CustomEvents = {
    'enterviewport' : {
        'event' : new CustomEvent('enterviewport', {
            bubbles: false,
            cancelable: false,
        }),
        'elements' : [],
        'handlers' : [],
        'startListen' : () => {
            document.addEventListener('scroll', throttle(CustomEvents.enterviewport.listener))
        },
        'stopListen' : () => {
            document.removeEventListener('scroll', throttle(CustomEvents.enterviewport.listener))
        },
        'isTriggered' : (element) => {
            return isInViewport(element);
        },
        'attach' : function (element, callback) {
            element.addEventListener('enterviewport', callback)
            if (CustomEvents.enterviewport.isTriggered(element)) {
                // console.log('inviewport!')
                element.dispatchEvent(CustomEvents.enterviewport.event);
                element.removeEventListener('enterviewport', callback)
                return;
            }
            if (CustomEvents.enterviewport.elements.length == 0) {
                CustomEvents.enterviewport.startListen();
            }
            CustomEvents.enterviewport.elements.push(element);
            CustomEvents.enterviewport.handlers.push(callback);
        },
        'detach' : function (element) {
            element.removeEventListener('enterviewport', CustomEvents.enterviewport.handlers[element])
            let index = CustomEvents.enterviewport.elements.indexOf(element)
            CustomEvents.enterviewport.elements.splice(index, 1)
            CustomEvents.enterviewport.handlers.splice(index, 1)
            if (CustomEvents.enterviewport.elements.length == 0) {
                CustomEvents.enterviewport.stopListen();
            }
        },
        'listener' : function (event) {
            CustomEvents.enterviewport.elements.forEach(element => {
                if (CustomEvents.enterviewport.isTriggered(element)) {
                    // console.log('inviewport!')
                    element.dispatchEvent(CustomEvents.enterviewport.event);
                    CustomEvents.enterviewport.detach(element);
                }
            });
        },
    },
};
export function addCustomEventListener(element, eventType, callback) {
    if (CustomEvents[eventType]) {
        CustomEvents[eventType].attach(element, callback);
    }
}

function isContainedInViewport(element) {
    let bounding = element.getBoundingClientRect();

    return bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

function isInViewport(element) {
    // console.log('not in view')
    let bounding = element.getBoundingClientRect();
    // console.log(bounding)

    let inVerticalView = (bounding.top >= 0 && (bounding.top <= window.innerHeight || bounding.top <= document.documentElement.clientHeight))
        || (bounding.bottom >= 0 && (bounding.bottom <= window.innerHeight || bounding.bottom <= document.documentElement.clientHeight));
    let inHorizontalView = (bounding.left >= 0 && (bounding.left <= window.innerWidth || bounding.left <= document.documentElement.clientWidth))
        || (bounding.right >= 0 && (bounding.right <= window.innerWidth || bounding.right <= document.documentElement.clientWidth));

    return inVerticalView && inHorizontalView;
}
